export const FOOTER_2_CONSTANTS = {
  FOOTER_FIELDS_CONFIG: [
    {
      fieldName: "status",
      label: "Footer Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Footer Section",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "gradient_start_color",
      label: "Gradient Start Color",
      value: "#3C398E",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Left side of gradient",
      required: false,
      defaultValue: "#3C398E",
    },
    {
      fieldName: "gradient_end_color",
      label: "Gradient End Color",
      value: "#00BFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Right side of gradient",
      required: false,
      defaultValue: "#00BFFF",
    },
    {
      fieldName: "copyright_text",
      label: "Copyright Text",
      value: "Copyright 2026 of [University Name]",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "e.g. Copyright 2026 of [University Name]",
      required: false,
      defaultValue: "Copyright 2026 of [University Name]",
    },
  ],
};
